import { normalizeSearch } from './cropLabels';
export const scientificLabel = row => {
  const name = row.scientific_name_verified || row.scientific_name || row.accepted_name || row.fao_botanical_original || '';
  const author = row.authorship || row.author || '';
  return author && !name.includes(author) ? `${name} ${author}` : name;
};
export const catalogMatches = (row, query) => [row.crop_display_group?.label_it, row.crop_display_group?.label_en, scientificLabel(row), row.label_it, row.label_en, row.name, ...Object.values(row.common_names || {}), ...Object.values(row.labels || {}), ...(row.synonyms || []), ...(row.verified_synonyms || []), ...(row.search_terms_it || [])].some(v => normalizeSearch(v).includes(normalizeSearch(query)));
export const taxonLabel = (row, lang, mode = 'common') => {
  const common = row.common_names?.[lang]; const scientific = scientificLabel(row);
  return common ? mode === 'scientific' ? `${scientific} — ${common}` : `${common} — ${scientific}` : scientific;
};

